import { connect } from 'react-redux';
import { IReduxRootState } from '../../reduxRootState.interface';
import NotificationsList from './NotificationsList';
import { Dispatch } from 'react';
import { NotificationsActions } from './notificationsActions';
import { NotificationAction } from './notificationsActionType';

const mapStateToProps = (state: IReduxRootState) => {
    return {
        notifications: state.notifications ? state.notifications.notifications : [],
    };
};

const mapDispatchToProps = (dispatch: Dispatch<NotificationAction>) => {
    return {
        removeNotification: (id: string) => {
            dispatch(NotificationsActions.removeNotification(id));
        },
    };
};

const NotificationsListContainer = connect(mapStateToProps, mapDispatchToProps)(NotificationsList);

export default NotificationsListContainer;
